import { type FC } from "react";
import { type FilterFormPropsBase } from "../types/props";
import { type ScheduleFiltersEnum } from "features/People/types";
import { FilterFormBuilder } from "../FilterFormBuilder/FilterFormBuilder";
import { getScheduleFilters } from "./scheduleFilters";

export const ScheduleFilterForm: FC<FilterFormPropsBase<ScheduleFiltersEnum>> = ({
  filterOptions,
  filter,
  updateFilter,
}) => {
  return (
    <FilterFormBuilder
      filterOptions={filterOptions}
      filter={filter}
      updateFilter={updateFilter}
      items={getScheduleFilters()}
    />
  );
};

export default ScheduleFilterForm;
